import React from 'react';

const LoadingSpinner = () => {
    return (
        <div className="spinner-inline">
            <div className="spinner-border spinner-border-sm text-primary ms-2" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    );
};

export default LoadingSpinner;